export const ALLOCATION_ROWS = [
  ["alloc_director", "10%"],
  ["alloc_writer", "10%"],
  ["alloc_distributor", "10%"],
  ["alloc_producer", "10%"],
  ["alloc_partner", "10%"],
  ["alloc_treasury", "10%"],
  ["alloc_buyback", "5%"],
  ["alloc_marshal", "1.8%"],
  ["alloc_metal", "3.2%"],
  ["alloc_investor", "30%"],
];
